<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="series"
            class="elevation-1"
          >
            <template v-slot:item.imagename="{ item }">
              <v-img :src="url + item.imagename" contain  height="50" width="50"/>
            </template>

            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Series</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>

                <!-- Dialogo -->
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" rounded small v-on="on">Nueva series</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <!-- Datos de la serie -->
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" >
                            <v-text-field v-model="editedItem.nomserie" label="Serie"></v-text-field>
                          </v-col>
                          <v-col cols="12" >
                            <v-file-input
                              accept="image/png, image/jpeg, image/bmp"
                              placeholder="Agrega una imagen"
                              prepend-icon="mdi-camera"
                              label="Avatar"
                              @change="cargar()"
                              v-model="files"
                            ></v-file-input>
                          </v-col>
                          <v-col cols="12" align="left">
                            <v-img :src="url + editedItem.imagename" contain width="100%" max-height="350" v-if="foto== ''"/>
                            <v-img :src="foto" contain width="100%" max-height="350"else/>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" dark @click="close" dense rounded>Cancel</v-btn>
                      <v-btn color="blue darken-1" dark @click="save"dense  rounded>Guardar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                class="mr-2"
                color="primary"
                @click="editItem(item), nModo = 2"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                color="primary"
                @click="dialog2 = true, idDelete = item.idserie"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="getSeries">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Subserie</v-card-title>
          <v-card-text>Al eliminar una serie, se eliminaran las subseries correspondientes a la serie</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog2 = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteItem">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import mixinsSerie from '@/mixins/mixinsSerie.js'
  export default {
    mixins:[mixinsSerie],

    data: () => ({
      dialog2: false,
      idDelete: 0,

      nModo: 1,
      formdata:'',
      url:'',
      files: [],
      foto:'',

      search:'',
      dialog: false,
      headers: [
        {
          text: 'Serie',
          align: 'start',
          sortable: false,
          value: 'nomserie',
        },
        { text: 'Foto', value: 'imagename' },
        { text: 'Actions', value: 'actions', sortable: false, align:'right' },
      ],
      series: [],
      editedIndex: -1,
      editedItem: {
        idserie:0,
        nomserie: '',
        imagename: '',
      },
      defaultItem: {
        idserie:0,
        nomserie: '',
        imagename: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva serie' : 'Editar Serie'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.getSeries()
      console.log(this.files)
      this.url = this.$http.options.root + 'fotos/'
    },

    methods: {
      editItem (item) {
        this.files = {name: item.imagename}
        this.editedIndex = this.series.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem () {
        this.$http.delete('clasificacion.serie.delete/' + this.idDelete).then(response=>{
          this.getSeries()
          this.dialog2 = false
        }).catch(error=>console.log(error))
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {

        var payload = {
          nomserie:  this.editedItem.nomserie,
          imagename: this.files.name,
          estatus: 1,
        }

        if(this.files.name == undefined){
          payload.imagename = ''
        }

        if (this.editedIndex > -1) {
          this.$http.put('clasificacion.serie.update/' + this.editedItem.idserie , payload).then(response=>{
            if(this.foto != ''){
              this.$http.post('imagenes', this.formdata).then(response=>{
                this.getSeries()
                this.foto=''
                this.files = []
              }).catch(error=>{console.log(error)})
            }
            this.getSeries()
          }).catch(error=>{console.log(error)})
        } else {
          console.log(this.formdata)
          this.$http.post('clasificacion.serie.add', payload).then(response=>{
            if(this.formdata == ''){
              this.getSeries()
              this.foto=''
              this.files = []
            }else{
              this.$http.post('imagenes', this.formdata).then(response=>{
                this.getSeries()
                this.foto=''
                this.files = []
              }).catch(error=>{console.log(error)})
            }
          }).catch(error=>{console.log(error)})
        }
        this.close()
      },

      cargar(){
        // creamos una variable tipo FormData
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file', this.files);
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(this.files, formData)
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          me.foto = reader.result
          me.formdata = formData
        };
      },
    },
  }
</script>
